import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { Button as ButtonRSUI, useToast } from '@redshelf/redshelf-ui';
import ReadOnlyTextField from 'components/ReadOnlyTextField';

const useStyles = makeStyles((theme) => {
  return {
    citationContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      margin: theme.spacing(1),
    },
    citationContentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
    },
    button: {
      margin: theme.spacing(1),
      padding: theme.spacing(1.5),
    },
    textField: {
      '& :not(.MuiOutlinedInput-inputMultiline).MuiInputBase-input.MuiOutlinedInput-input':
        {
          padding: theme.spacing(1.5),
          '-webkit-text-fill-color': theme.palette.grey[700], // for Safari
        },
      '& .MuiOutlinedInput-inputMultiline': {
        '-webkit-text-fill-color': theme.palette.grey[700], // for Safari
      },
    },
  };
});

const getCitationContentProps = (props) => {
  const buttonCommonArgs = {
    variant: 'secondary',
    className: props.classes.button,
  };
  const textFieldCommonArgs = {
    variant: 'outlined',
    className: props.classes.textField,
    disabled: true,
  };
  return [
    {
      textField: {
        ...textFieldCommonArgs,
        label: 'Citation',
        value: props.citationText,
        'aria-label': 'Citation',
      },
      button: {
        ...buttonCommonArgs,
        onClick: () =>
          props.handleButtonClick(
            props.citationTexts[props.currentCitationStyleIndex],
            "You've successfully copied a citation to your clipboard.",
          ),
        content: 'Copy Citation',
      },
    },
    {
      textField: {
        ...textFieldCommonArgs,
        label: 'Bibliographical Entry',
        value: props.bibliographyText,
        rows: 4,
        multiline: true,
        'aria-label': 'Bibliographical Entry',
      },
      button: {
        ...buttonCommonArgs,
        onClick: () =>
          props.handleButtonClick(
            props.bibliographyTexts[props.currentCitationStyleIndex],
            "You've successfully copied a bibliographical entry to your clipboard.",
          ),
        content: 'Copy Bibliographical Entry',
      },
    },
  ];
};

const CitationComponent = ({ ...props }) => {
  const classes = useStyles();
  const { enqueueToast } = useToast();

  const handleButtonClick = (writeText, toastText) => {
    navigator.clipboard?.writeText(writeText);
    enqueueToast(toastText, { variant: 'success' });
    if (props.onClose) {
      props.onCloseAll();
    }
  };

  const citationContentProps = getCitationContentProps({
    ...props,
    classes,
    handleButtonClick,
  });

  return (
    <div className={classes.citationContainer}>
      {citationContentProps.map((prop) => {
        const {
          textField: { label, value },
          button: { content, ...button },
        } = prop;
        return (
          <div key={label} className={classes.citationContentWrapper}>
            <ReadOnlyTextField
              id={`${label.replace(/\s/g, '-').toLowerCase()}-field`}
              label={label}
              content={value}
            />
            <ButtonRSUI {...button}>{content}</ButtonRSUI>
          </div>
        );
      })}
    </div>
  );
};

CitationComponent.propTypes = {
  // Override or extend the styles applied to the component
  classes: PropTypes.object,
  // @ignore
  className: PropTypes.string,
  citationTexts: PropTypes.array,
  citationText: PropTypes.string,
  bibliographyTexts: PropTypes.array,
  bibliographyText: PropTypes.string,
  currentCitationStyleIndex: PropTypes.number,
  onClose: PropTypes.func,
};

export default CitationComponent;
